import ExpressionLight from "../../../../contents/images/features/hogql/expression-light.png";
import ExpressionDark from "../../../../contents/images/features/hogql/expression-dark.png";
import SQLLight from "../../../../contents/images/features/hogql/sql-light.png";
import SQLDark from "../../../../contents/images/features/hogql/sql-dark.png";
import WarehouseLight from "../../../../contents/images/features/hogql/warehouse-light.png";
import WarehouseDark from "../../../../contents/images/features/hogql/warehouse-dark.png";
import * as React from 'react';
export default {
  ExpressionLight,
  ExpressionDark,
  SQLLight,
  SQLDark,
  WarehouseLight,
  WarehouseDark,
  React
};